import loadMore from './modules/loadMore';

window.addEventListener('load', () => {
    loadMore.init();
}, false);
